var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplateAccount = function SvgTemplateAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "template_account_svg2__a",
    x1: -8.88,
    x2: 204.75,
    y1: -7.07,
    y2: 194.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__c",
    x1: -10.28,
    x2: 203.35,
    y1: -5.58,
    y2: 196.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__d",
    x1: -11.78,
    x2: 201.86,
    y1: -4,
    y2: 197.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__e",
    x1: -13.18,
    x2: 200.45,
    y1: -2.51,
    y2: 199.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__f",
    x1: -7.91,
    x2: 205.73,
    y1: -8.1,
    y2: 193.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__g",
    x1: -12.21,
    x2: 201.43,
    y1: -3.54,
    y2: 198.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__h",
    x1: -9.31,
    x2: 204.32,
    y1: -6.61,
    y2: 195.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__i",
    x1: -13.61,
    x2: 200.02,
    y1: -2.06,
    y2: 199.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__j",
    x1: -10.8,
    x2: 202.83,
    y1: -5.03,
    y2: 196.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__k",
    x1: -15.1,
    x2: 198.53,
    y1: -0.47,
    y2: 201.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__l",
    x1: -12.21,
    x2: 201.43,
    y1: -3.54,
    y2: 198.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__m",
    x1: -16.51,
    x2: 197.13,
    y1: 1.01,
    y2: 202.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__n",
    x1: 12.33,
    x2: 225.97,
    y1: -29.54,
    y2: 172.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__o",
    x1: 9.27,
    x2: 222.9,
    y1: -26.29,
    y2: 175.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_account_svg2__a",
    id: "template_account_svg2__p",
    x1: 9.44,
    x2: 223.07,
    y1: -26.47,
    y2: 175.16
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10 46.67h26.67c5.52 0 10-4.48 10-10V10c0-5.52-4.48-10-10-10H10C4.48 0 0 4.48 0 10v26.67c0 5.52 4.48 10 10 10M6.67 10c0-1.84 1.49-3.33 3.33-3.33h26.67C38.51 6.67 40 8.16 40 10v26.67c0 1.84-1.49 3.33-3.33 3.33H10c-1.84 0-3.33-1.49-3.33-3.33z",
    style: {
      fill: "url(#template_account_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 96.67h26.67c5.52 0 10-4.48 10-10V60c0-5.52-4.48-10-10-10H60c-5.52 0-10 4.48-10 10v26.67c0 5.52 4.48 10 10 10M56.67 60c0-1.84 1.49-3.33 3.33-3.33h26.67c1.84 0 3.33 1.49 3.33 3.33v26.67c0 1.84-1.49 3.33-3.33 3.33H60c-1.84 0-3.33-1.49-3.33-3.33z",
    style: {
      fill: "url(#template_account_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33 150H140c5.52 0 10-4.48 10-10v-26.67c0-5.52-4.48-10-10-10h-26.67c-5.52 0-10 4.48-10 10V140c0 5.52 4.48 10 10 10M110 113.33c0-1.84 1.49-3.33 3.33-3.33H140c1.84 0 3.33 1.49 3.33 3.33V140c0 1.84-1.49 3.33-3.33 3.33h-26.67c-1.84 0-3.33-1.49-3.33-3.33z",
    style: {
      fill: "url(#template_account_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 153.33h-26.67c-5.52 0-10 4.48-10 10V190c0 5.52 4.48 10 10 10H190c5.52 0 10-4.48 10-10v-26.67c0-5.52-4.48-10-10-10m3.33 36.67c0 1.84-1.49 3.33-3.33 3.33h-26.67c-1.84 0-3.33-1.49-3.33-3.33v-26.67c0-1.84 1.49-3.33 3.33-3.33H190c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#template_account_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.67 20H20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-3.33c-1.84 0-3.33 1.49-3.33 3.33S14.83 20 16.67 20",
    style: {
      fill: "url(#template_account_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.67 33.33H30c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H16.67c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#template_account_svg2__g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 70H70c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-3.33c-1.84 0-3.33 1.49-3.33 3.33S64.83 70 66.67 70",
    style: {
      fill: "url(#template_account_svg2__h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 83.33H80c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H66.67c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#template_account_svg2__i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 123.33h3.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H120c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#template_account_svg2__j)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 136.67h13.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H120c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#template_account_svg2__k)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 173.33h3.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H170c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#template_account_svg2__l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.33 180H170c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h13.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#template_account_svg2__m)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67 20h10c3.68 0 6.67 2.98 6.67 6.67v5.29l-.98-.98a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c1.3 1.3 3.41 1.3 4.71 0l6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-.98.98v-5.29c0-7.36-5.97-13.33-13.33-13.33h-10c-1.84 0-3.33 1.49-3.33 3.33S54.84 20 56.68 20Z",
    style: {
      fill: "url(#template_account_svg2__n)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 73.33h10c3.68 0 6.67 2.98 6.67 6.67v5.29l-.98-.98a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c1.3 1.3 3.41 1.3 4.71 0l6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-.98.98V80c0-7.36-5.97-13.33-13.33-13.33h-10c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33Z",
    style: {
      fill: "url(#template_account_svg2__o)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 123.33h10c3.68 0 6.67 2.98 6.67 6.67v5.29l-.98-.98a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c1.3 1.3 3.41 1.3 4.71 0l6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-.98.98V130c0-7.36-5.97-13.33-13.33-13.33h-10c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33Z",
    style: {
      fill: "url(#template_account_svg2__p)",
      strokeWidth: 0
    }
  }));
};
export default SvgTemplateAccount;